module.exports = __webpack_public_path__ + "static/path-635616340fccf33699ce19fc75fdab4f.mp4";